module.exports = "pegasus/assets/circleline-facebook.gif";